import { protectedResourceRequest } from 'oauth4webapi';
import { z } from 'zod';
import { OpenIdError } from './OpenIdError';
const CONTENT_TYPE = 'application/x-www-form-urlencoded;charset=UTF-8';
const GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:uma-ticket';
const RESPONSE_MODE = 'permissions';
const HTTP_OK = 200;
const umaPermissionsResponseSchema = z.array(z.object({
    rsid: z.string(),
    scopes: z.array(z.string()).optional(),
}));
export const getUmaPermissions = async ({ authorizationServer, accessToken, audience, }) => {
    const { token_endpoint: tokenEndpoint } = authorizationServer;
    if (!tokenEndpoint) {
        throw new Error("Provider doesn't have a token endpoint");
    }
    const headers = new Headers({
        'content-type': CONTENT_TYPE,
    });
    const body = new URLSearchParams({
        grant_type: GRANT_TYPE,
        response_mode: RESPONSE_MODE,
        audience,
    });
    const response = await protectedResourceRequest(accessToken, 'POST', new URL(tokenEndpoint), headers, body);
    if (response.status !== HTTP_OK) {
        throw new OpenIdError(`Request failed with status code ${response.status}`, { data: { error: 'Invalid request' } });
    }
    const json = await response.json();
    const permissions = umaPermissionsResponseSchema.parse(json);
    return permissions;
};
